// extracted by mini-css-extract-plugin
export default {"rating":"Rz-z","numberOfStars":"Sz-z","count":"Tz-z","barGraphSpacing":"Uz-z","barGraph":"Vz-z"};